<form [formGroup]="leaseService.entity">
    <div class="grid flex-column align-items-center">
  
      <!-- Sección de Clientes -->
      <div class="col-12 md:col-9">
        <div class="field">
          <label for="client">
            <span class="p-error">*</span>Cliente:
          </label>
          <div class="flex justify-content-center flex-column">
            <p-dropdown 
              formControlName="client" 
              appendTo="body" 
              [panelStyle]="{'width': '100%' }" 
              [style]="{'height': '45px'}" 
              scrollHeight="150px" 
              [options]="leaseService.clients"
              optionLabel="label"
              optionValue="value"
              [filter]="true"
              filterBy="label,rfc"
              (onFilter)="onClientFilter($event)"
              [emptyFilterMessage]="'Sin coincidencias'"
              [showClear]="true"
              placeholder="Selecciona un cliente"
              (onChange)="leaseService.onSelectClient($event)"
            >
              <ng-template pTemplate="selectedItem">
                <div class="flex align-items-center" *ngIf="leaseService.entity.get('client')?.value">
                  <div>{{leaseService.getClientName(leaseService.entity.get('client')?.value)}}</div>
                </div>
              </ng-template>
              <ng-template let-client pTemplate="item">
                <div class="flex align-items-center">
                  <div>{{ client.label }}</div>
                </div>
              </ng-template>
            </p-dropdown>
            <ng-container *ngIf="leaseService.entity.get('client')?.invalid && (leaseService.entity.get('client')?.dirty || leaseService.entity.get('client')?.touched)">
              <small class="p-error" *ngIf="leaseService.entity.get('client')?.errors?.['required']">El cliente es obligatorio.</small>
            </ng-container>
          </div>
        </div>
      </div>
  
      <!-- Sección de Cotizaciones -->
      <div class="col-12 md:col-9">
        <div class="field">
          <label for="quotationParametersId">
            <span class="p-error">*</span>Cotización:
          </label>
          <div class="flex justify-content-center flex-column">
            <p-dropdown 
              formControlName="quotationParametersId" 
              appendTo="body" 
              [panelStyle]="{'width': '100%' }" 
              [style]="{'height': '45px'}" 
              scrollHeight="150px" 
              [options]="leaseService.quotations" 
              optionLabel="label" 
              optionValue="value" 
              [filter]="true" 
              filterBy="label" 
              [showClear]="true"
              placeholder="Selecciona una cotización"
            >
              <ng-template pTemplate="selectedItem">
                <div class="flex align-items-center" *ngIf="leaseService.entity.get('quotationParametersId')?.value">
                  <div class="tunned">{{leaseService.getQuotationParametersName(leaseService.entity.get('quotationParametersId')?.value)}}</div>
                </div>
              </ng-template>
              <ng-template let-quotation pTemplate="item">
                <div class="flex align-items-center">
                  <div>{{ quotation.label }}</div>
                </div>
              </ng-template>
            </p-dropdown>
            <ng-container *ngIf="leaseService.entity.get('quotationParametersId')?.invalid && (leaseService.entity.get('quotationParametersId')?.dirty || leaseService.entity.get('quotationParametersId')?.touched)">
              <small class="p-error" *ngIf="leaseService.entity.get('quotationParametersId')?.errors?.['required']">La cotización es obligatoria.</small>
            </ng-container>
          </div>
        </div>
      </div>
      
    </div>
  </form>
